import { NgModule } from '@angular/core';
import { ImgPreviewDirective } from './img-preview.directive';

@NgModule({
    declarations: [
        ImgPreviewDirective
    ],
    imports: [],
    exports: [
        ImgPreviewDirective
    ]
})
export class NcImgPreviewModule { }